import { NavItemType } from 'types';
import { IconFolders, IconHexagonLetterH, IconFiles, IconLayoutDashboard, IconFolder, IconTimelineEventText, IconBuildingCommunity } from '@tabler/icons-react';

const global: NavItemType = {
  id: 'global',
  title: 'global',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'dashboard',
      type: 'item',
      url: '/dashboard',
      icon: IconLayoutDashboard
    },
    // Above DocHub because that is its place in the hierarchy: entities are what documents describe
    // and what projects analyse. docs/adr/0003-entities.md
    {
      id: 'entities',
      title: 'entities',
      type: 'item',
      url: '/entities',
      icon: IconBuildingCommunity
    },
    {
      id: 'library',
      title: 'DocHUB',
      type: 'item',
      url: '/doc-hub',
      icon: IconHexagonLetterH
    },
    {
      id: 'projects',
      title: 'projects',
      type: 'item',
      url: '/projects',
      icon: IconFolders
    }
  ]
};

export default global;